export default (node) => {
	var is_mobile = false;
	is_mobile = (window.matchMedia("(max-width: 992px)").matches) ? true : false;
	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
	    is_mobile = true;
	}

	if (!is_mobile) {
		var coll = document.querySelectorAll(".collapse");

		coll.forEach(col => {
			const btn = document.querySelector(`[aria-controls='${col.id}']`);
			const li = btn.closest('li');

			li.addEventListener("mouseenter", function() {

				var is_active = (window.getComputedStyle(col).display !== 'none') ? true : false;

				if (!is_active) {
					// li.closest('li').classList.add('active');
					slideDown(col);
					// btn.classList.add('active');
					li.classList.add('active');

					coll.forEach(sub => {

						if (sub === col) { return }
						const sub_btn = document.querySelector(`[aria-controls='${sub.id}']`);
						sub_btn.closest('li').classList.remove('active');
						slideUp(sub);
					})
				}
			});

			// li.addEventListener("mouseleave", function() {
			// 	li.closest('li').classList.remove('active');
			//     // col.style.maxHeight = "0px";
			//     slideUp(col);

			//     // li.addEventListener('transitionend', () => {
			//     // 	col.style.display = "none";
			//     // }, { once: true })
			// });
		})

		let slideUp = (target, duration=300) => {
		    target.style.transitionProperty = 'height, margin, padding';
		    target.style.transitionDuration = duration + 'ms';
		    target.style.boxSizing = 'border-box';
		    target.style.height = target.offsetHeight + 'px';
		    target.offsetHeight;
		    target.style.overflow = 'hidden';
		    target.style.height = 0;
		    target.style.paddingTop = 0;
		    target.style.paddingBottom = 0;
		    target.style.marginTop = 0;
		    target.style.marginBottom = 0;
		    window.setTimeout( () => {
		      target.style.display = 'none';
		      target.style.removeProperty('height');
		      target.style.removeProperty('padding-top');
		      target.style.removeProperty('padding-bottom');
		      target.style.removeProperty('margin-top');
		      target.style.removeProperty('margin-bottom');
		      target.style.removeProperty('overflow');
		      target.style.removeProperty('transition-duration');
		      target.style.removeProperty('transition-property');
		      //alert("!");
		    }, duration);
		  }

		  let slideDown = (target, duration=300) => {
		    target.style.removeProperty('display');
		    let display = window.getComputedStyle(target).display;

		    if (display === 'none')
		      display = 'block';

		    target.style.display = display;
		    let height = target.offsetHeight;
		    target.style.overflow = 'hidden';
		    target.style.height = 0;
		    target.style.paddingTop = 0;
		    target.style.paddingBottom = 0;
		    target.style.marginTop = 0;
		    target.style.marginBottom = 0;
		    target.offsetHeight;
		    target.style.boxSizing = 'border-box';
		    target.style.transitionProperty = "height, margin, padding";
		    target.style.transitionDuration = duration + 'ms';
		    target.style.height = height + 'px';
		    target.style.removeProperty('padding-top');
		    target.style.removeProperty('padding-bottom');
		    target.style.removeProperty('margin-top');
		    target.style.removeProperty('margin-bottom');
		    window.setTimeout( () => {
		      target.style.removeProperty('height');
		      target.style.removeProperty('overflow');
		      target.style.removeProperty('transition-duration');
		      target.style.removeProperty('transition-property');
		    }, duration);
		  }
		   let slideToggle = (target, duration = 300) => {
		    if (window.getComputedStyle(target).display === 'none') {
		      return slideDown(target, duration);
		    } else {
		      return slideUp(target, duration);
		    }
		  }
	}
};